import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M4.5 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M2.5 12.216L4.997 9.72l1.563 1.56 4.444-4.443 2.5 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M12 13.5H4A1.5 1.5 0 012.5 12V4A1.5 1.5 0 014 2.5h8A1.5 1.5 0 0113.5 4v8a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.324l3.746-3.746 2.342 2.342 6.666-6.665 3.75 3.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 18a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 36.648l7.492-7.492 4.684 4.684 13.332-13.33 7.5 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
export var ImageNoImage = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});